import { Space, Typography, Button, notification } from "antd";
import { Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import * as Yup from "yup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { updateProjectById } from "../../store/api/projects";

const { Text } = Typography;

const ContentForm = ({ project }) => {
  const formikRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const initialValues = {
    content: project ? project?.content : null,
  };

  const validationSchema = Yup.object({
    content: Yup.mixed(),
  });

  const onSubmit = (values) => {
    setLoading(true);

    const data = {
      content: values.content,
      id: project.id,
    };

    updateProjectById(project.id, data)
      .then(({ data }) => {
        notification.success({ message: data.message });
        formikRef.current.resetForm({ values });
      })
      .catch((error) => {
        notification.error({ message: error.response.data.message });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          dirty,
          errors,
          touched,
          values,
          handleChange,
          setFieldValue,
          resetForm,
        }) => {
          return (
            <Form>
              <Space direction="vertical" style={{ width: "100%" }} size={20}>
                <div>
                  <ReactQuill
                    theme="snow"
                    value={values.content}
                    onChange={(value) => setFieldValue("content", value)}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, 3, 4, false] }],
                        ["bold", "italic", "underline", "strike", "blockquote"],
                        [
                          { list: "ordered" },
                          { list: "bullet" },
                          { indent: "-1" },
                          { indent: "+1" },
                        ],
                        ["link"],
                        ["clean"],
                      ],
                    }}
                    formats={[
                      "header",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "blockquote",
                      "list",
                      "bullet",
                      "indent",
                      "link",
                    ]}
                  />
                  {errors.content && touched.content ? (
                    <Text type="danger">{errors.content}</Text>
                  ) : null}
                </div>
                <div style={{ display: "flex", gap: "14px", flexWrap: "wrap" }}>
                  <Button
                    type="secondary"
                    htmlType="button"
                    disabled={!dirty || loading}
                    onClick={resetForm}
                  >
                    Cancel
                  </Button>
                  <Button
                    loading={loading}
                    type="primary"
                    htmlType="submit"
                    disabled={!dirty || loading}
                  >
                    Save
                  </Button>
                </div>
              </Space>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default ContentForm;
